import { WindowTypes } from "../../../app/services/window-dialogs/window.event";
import { UserRolesService } from "../user.roles.service";
import { GlobalService } from "../global.service";

export class WindowContext<T> {

    ID: string;
    WindowType: WindowTypes;
    Data: T;

    UserRolesService: UserRolesService;
    GlobalService: GlobalService;

}